import React from 'react';
import styles from '../Navbar.module.css';

const SacuvaniIkonica = (props) => (
<svg className={styles.sadrzajMainDugmeIkonica} width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clipPath="url(#clip0_3719_17226)">
<path fillRule="evenodd" clipRule="evenodd" d="M20.0761 4C18.0705 4 16.2645 4.88988 15 6.31086C13.7359 4.88988 11.9295 4 9.92387 4C6.10151 4 3.00258 7.23125 3 11.2183V11.248C3.00258 12.311 3.18409 13.3341 3.49935 14.3112C3.49935 14.3112 3.78796 15.1998 4.04301 15.6892C6.96172 21.9438 15 26 15 26C15 26 23.0383 21.9438 25.957 15.6892C25.957 15.6892 26.3338 14.8556 26.5006 14.3112C26.8043 13.3216 27 12.2947 27 11.223C27 7.23383 23.9002 4 20.0761 4Z" fill="#1070D1"/>
</g>
<defs>
<clipPath id="clip0_3719_17226">
<rect width="24" height="22" fill="white" transform="translate(3 4)"/>
</clipPath>
</defs>
</svg>

);

export default SacuvaniIkonica;